// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "82b899c0cc6015aa1d8a" + "/js/" + chunkId + ".js";
};